import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { WhatsAppButton } from './components/layout/WhatsAppButton';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { ProgramsPage } from './pages/ProgramsPage';
import { ApplyPage } from './pages/ApplyPage';
import { ContactPage } from './pages/ContactPage';
import { AdminLoginPage } from './pages/admin/AdminLoginPage';
import { AdminDashboardPage } from './pages/admin/AdminDashboardPage';
// Layout wrapper to conditionally render Navbar/Footer
function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  return <div className="min-h-screen flex flex-col font-sans text-gray-900 bg-[#faf8f5]" data-id="element-0">
      {!isAdminRoute && <Navbar data-id="element-1" />}
      <main className="flex-1" data-id="element-2">{children}</main>
      {!isAdminRoute && <Footer data-id="element-3" />}
      {!isAdminRoute && <WhatsAppButton data-id="element-4" />}
    </div>;
}
export function App() {
  return <Router data-id="element-5">
      <Layout data-id="element-6">
        <Routes data-id="element-7">
          <Route path="/" element={<HomePage data-id="element-9" />} data-id="element-8" />
          <Route path="/about" element={<AboutPage data-id="element-11" />} data-id="element-10" />
          <Route path="/services" element={<ServicesPage data-id="element-13" />} data-id="element-12" />
          <Route path="/programs" element={<ProgramsPage data-id="element-15" />} data-id="element-14" />
          <Route path="/apply" element={<ApplyPage data-id="element-17" />} data-id="element-16" />
          <Route path="/contact" element={<ContactPage data-id="element-19" />} data-id="element-18" />
          <Route path="/admin" element={<AdminLoginPage data-id="element-21" />} data-id="element-20" />
          <Route path="/admin/dashboard" element={<AdminDashboardPage data-id="element-23" />} data-id="element-22" />
        </Routes>
      </Layout>
    </Router>;
}